import { useState } from "react";
import { api } from "api";

const ENDPOINT = "prod_bodega_inventario_inicial";

export const InventarioInicialApi = () => {
    const [cargando, setCargando] = useState(false);

    // configuración del acopio más la fecha máxima permitida y si todavía se
    // puede modificar
    const getConfiguracion = async () => {
        try {
            setCargando(true);
            const response = await api.get(`${ENDPOINT}/actual`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getProductos = async (params) => {
        return api
            .get(`${ENDPOINT}/productos`, params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const guardarInventarioInicial = async (id, data) => {
        try {
            setCargando(true);

            const response = id
                ? await api.put(`${ENDPOINT}/${id}`, data)
                : await api.post(ENDPOINT, data);

            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const eliminarInventarioInicial = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`${ENDPOINT}/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // responde con error si la fila guardada ya no se puede eliminar
    const validarEliminacionDetalle = async (detalleId) => {
        try {
            setCargando(true);
            const response = await api.get(
                `${ENDPOINT}/validar_eliminacion_detalle/${detalleId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const eliminarDetalleInventario = async (detalleId) => {
        try {
            setCargando(true);
            const response = await api.eliminar(
                `${ENDPOINT}/eliminar_detalle/${detalleId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getConfiguracion,
        getProductos,
        guardarInventarioInicial,
        eliminarInventarioInicial,
        validarEliminacionDetalle,
        eliminarDetalleInventario,

        cargando,
    };
};
